import React from 'react';
import {
	AirlineList,
	Filter
} from './components/index.jsx';
import I18 from '../shared/I18';
import { translate } from 'react-i18next';

class AirlineListApp extends React.Component {

    constructor(props) {
        super(props);
		this.init();
		this.onModeChange = this.onModeChange.bind(this);
		this.onFilterChange = this.onFilterChange.bind(this);
		this.onSortingChange = this.onSortingChange.bind(this);
	}

	init() {
		const airlineDataContainer = document.getElementById('js-airline-data');
		const data = airlineDataContainer ? JSON.parse(airlineDataContainer.dataset.airlines) : [];

		this.state = {
			mode: this.props.mode || 'list',
			data: data,
			filter: this.props.filter || '',
			sorting: this.props.sorting || Filter.ORDER_ALPHABETICAL_ASC
		}
	}

	onModeChange(mode) {
		this.setState({
			mode: mode
		});
	}

	onFilterChange(evt) {
		this.setState({
			filter: evt.target.value
		});
	}

	onSortingChange(sorting) {
		this.setState({
			sorting: sorting.target.value
		});
	}

	render(){
		return (
			<div>
				<Filter
					mode={this.state.mode}
					filter={this.state.filter}
					onModeChange={this.onModeChange}
					onFilterChange={this.onFilterChange}
					onSortingChange={this.onSortingChange}
				/>
				<AirlineList
					data={this.state.data}
					mode={this.state.mode}
					filter={this.state.filter}
					sorting={this.state.sorting}
				/>
			</div>
		)
	}


}
export default translate(['jetbeds'], { wait: true })(AirlineListApp);


// WEBPACK FOOTER //
// ./AirlineListApp/AirlineListApp.js